import styled from 'styled-components';

export const TabsContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  margin: 1.5rem auto;
  
  @media(min-width: 768px) {
    width: 70%;
    margin: 2rem auto;
  }
`

export const TabComponent = styled.div<{$isActive: boolean}>`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0.75rem 0;
  width: 50%;
  box-sizing: border-box;
  background-color: ${({$isActive}) => $isActive ? 'var(--primary-blue, #FB7672)' : '#fff'};
  color: ${({$isActive}) => $isActive ? '#fff' : 'var(--primary-blue, #FB7672)'};
  font-size: 16px;
  font-weight: 600;
  border: solid 1px var(--primary-blue, #0B4598);
  margin-bottom: 1rem;
  
  &:first-child {
    border-bottom-left-radius: 0.5rem;
    border-top-left-radius: 0.5rem;
  }

  &:nth-last-child(2) {
    border-bottom-right-radius: 0.5rem;
    border-top-right-radius: 0.5rem;
  }
`